import React from 'react';
import './ConfirmBox.css';

interface ConfirmBoxProps {
  title: string;
  message: string;
  confirmAction: () => void;
  cancelAction?: () => void;
  isVisible: boolean;
  onClose?: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmBox: React.FC<ConfirmBoxProps> = ({ 
  title, 
  message, 
  confirmAction, 
  cancelAction,
  isVisible, 
  onClose,
  confirmText = 'Confirm',
  cancelText = 'Cancel'
}) => {
  if (!isVisible) return null;

  const handleConfirmClick = () => {
    confirmAction();
    if (onClose) {
      onClose();
    }
  };

  const handleCancelClick = () => {
    if (cancelAction) {
      cancelAction();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div className="confirm-box-overlay" onClick={handleBackdropClick}>
      <div className="confirm-box">
        <div className="confirm-box-header">
          <h3 className="confirm-box-title">{title}</h3>
        </div>
        
        <div className="confirm-box-content">
          <p className="confirm-box-message">{message}</p>
        </div>
        
        <div className="confirm-box-actions">
          <button 
            className="confirm-box-button confirm-box-button-secondary"
            onClick={handleCancelClick}
          >
            {cancelText}
          </button>
          <button 
            className="confirm-box-button confirm-box-button-primary"
            onClick={handleConfirmClick}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBox;
